import AssociationDetailInfo from "./AssociationDetailInfo";
import AssociationNotesForm from "./AssociationNotes";
import AssociationDocumentsForm from "./AssociationDocuments";
import AssociationHistoryForm from "./AssociationHistory";
import AssociationCertificateNotesForm from "./AssociationCertificate";
import AssociationContactForm from "./AssociationContact";
import AssociationSubdivisionForm from "./AssociationsSubdivision";
import AssociatinonFee from "./AssociationFee";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import { useState } from "react";



const AssociationDetailsForm = () => {

    const [status, setStatus] = useState<any>();
    const [overrideStatus, setOverrideStatus] = useState<any>();

    return (
        <>
            <div className="md:grid grid-cols-9 gap-4 mt-4">

                <div className="col-span-5 space-y-4">
                    <AssociationDetailInfo isReadOnly={!hasPermission(["ASSOC-U"])} setStatus={setStatus} setOverrideStatus={setOverrideStatus} status={status}/>
                    <AssociatinonFee status={status} overrideStatus={overrideStatus}/>
                    <AssociationContactForm />
                    <AssociationSubdivisionForm />
                </div>


                <div className="col-span-4">
                    <AssociationNotesForm />
                    <AssociationDocumentsForm />
                    <AssociationHistoryForm />
                    {hasPermission(["CRTNOT-V"]) &&
                        <AssociationCertificateNotesForm />}

                </div>
            </div>
        </>
    );
};

export default AssociationDetailsForm;